/* eslint-disable */
import React, { Component } from 'react';
import moment from 'moment';

export default class ETACell extends Component {
    render() {
        let statusFilterImage;
        const { value } = this.props;
        const { job } = this.props;
        const clockin = job.booking ? job.booking.clock_in : null;
        const firstSeen = job.booking ? job.booking.first_seen : null;
        const now = new Date();

        // TODO Fix this crap
        if (value) {
            if (value[0] == 'minutes') {
                if (value[2] == '-' && value[1] > 15) {
                    statusFilterImage = '/static/images/green-circle.png';
                } else if (value[2] == '-') {
                    statusFilterImage = '/static/images/orange-circle.png';
                } else {
                    statusFilterImage = '/static/images/red-circle.png';
                }
            } else if (value[2] == '-') {
                statusFilterImage = '/static/images/green-circle.png';
            } else {
                statusFilterImage = '/static/images/red-circle.png';
            }
            if (clockin && new Date().toISOString() >= job.start_datetime) {
                return <span>Clocked-in</span>;
            }
            if (firstSeen) {
                return <span>Arrived</span>;
            }

            if (job.start_datetime < now.toISOString()) {
                const formatNumber = n => (n > 9 ? n : `0${n}`);

                const eta = moment(job.booking.eta);
                const etaUpdated = moment(job.booking.eta_updated);
                const minutesAway = moment.duration(eta.diff(etaUpdated));
                const hoursLate = Math.abs(minutesAway.hours());
                const minutesLate = formatNumber(
                    Math.abs(minutesAway.minutes()),
                );

                if (hoursLate >= 1) {
                    return (
                        <span className="rt-status-cell">
                            {hoursLate}h {minutesLate}m away
                        </span>
                    );
                }
                return (
                    <span className="rt-status-cell">{minutesLate}m away</span>
                );
            }

            return (
                <span className="rt-status-cell">
                    <img src={statusFilterImage} alt="Status" />
                    {`${value[2]} ${value[1]} ${value[0]}`}
                </span>
            );
        }
        return <span className="rt-status-cell">N/A</span>;
    }
}
